import React from 'react';
import Field from "./../field";
import Grid from '@material-ui/core/Grid';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import {withTranslation} from "react-i18next";

class FieldNestedSingleEntity extends React.Component {
    constructor(props) {
        super(props);
        const {defaultValue} = this.props;
        this.state = {
            checkedCheckbox: defaultValue !== undefined,
        };
    }
    handleChange = (e) => {
        const state = this;
        this.setState({ ...state, checkedCheckbox: e.target.checked});
    };
    render() {
        const {name, scheme, defaultValue, refs, i18n} = this.props;
        const {checkedCheckbox} = this.state;
        const {handleChange} = this;
        refs[name] = {};
        const isLabelEn = i18n.language === 'en' && scheme.label_en
        return (
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={checkedCheckbox}
                                onChange={handleChange}
                                color="primary"
                            />
                        }
                        label={`${isLabelEn ? scheme.label_en : scheme.label}`} />
                </Grid>
                {checkedCheckbox
                    ? Object.keys(scheme.type.element_fields).map(elementField => {
                        return (
                            <Grid item xs={12} key={elementField}>
                                <Field
                                    name={elementField}
                                    scheme={scheme.type.element_fields[elementField]}
                                    defaultValue={defaultValue ? defaultValue[elementField] : undefined}
                                    refs={refs[name]} />
                            </Grid>
                        )
                    })
                    : null}
            </Grid>
        );
    }
}
export default withTranslation()(FieldNestedSingleEntity);